import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

/** @see docs/API_SYSTEM_ACCESS.md */
export async function fetchRoleList(listQuery) {
  const { data: raw } = await request.get('/system/role', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
